import { TbNumber123 } from "react-icons/tb";

const getBigNumberDataFields = () => {
  return [
    //big number
    {
      title: "Value",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    //date x
    {
      title: "X-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
  ];
};

const getBigNumberCustomizationFields = () => {
  return [
    {
      title: "Icon",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isIconVisible",
      innerComponents: [
        {
          title: "Icon",
          type: "imageUpload",
          reduxKey: "imageUrl",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Image Width",
          type: "range",
          reduxKey: "imageWidth",
          defaultValue: 10,
          minValue: 10,
          maxValue: 100,
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
      ],
    },
    {
      title: "Value",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isNumberVisible",
      innerComponents: [
        {
          title: "Color",
          type: "fontColor",
          reduxKey: "numberFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isNumberBold",
          isParent: true,
        },
        {
          title: "Size",
          type: "range",
          reduxKey: "numberFontSize",
          defaultValue: 70,
          minValue: 10,
          maxValue: 100,
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
      ],
    },

    //without toggle
    //font
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Label",
          type: "text",
          defaultValue: "your text here...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "label",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Label Size",
          type: "range",
          defaultValue: 92,
          minValue: 10,
          maxValue: 100,
          reduxKey: "labelFontSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Label Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: true,
          reduxKey: "isLabelBold",
          isParent: true,
        },
        {
          title: "Label Alignment",
          type: "SELECT_BOX",
          reduxKey: "labelAlignment",
          options: [
            { label: "Top", value: "top" },
            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Top", value: "top" },
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },
  ];
};
const getBigNumberchartDetails = () => {
  return {
    chartType: "echarts",
    imageSrc: "/graph_img/bignumber.png",
    label: "BigNumber",
    value: "bigNumber",
    icon: <TbNumber123 className="text-xl text-blue-950" />,
    fileName: "BigNumberComp.js",
  };
};

export {
  getBigNumberCustomizationFields,
  getBigNumberDataFields,
  getBigNumberchartDetails,
};
